import { SpinnerState } from './../../../components/spinner/spinner.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import 'rxjs/add/observable/of';
import { FormControl, Validators } from '@angular/forms';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { ManageUser } from '../../../models/centre/manage-user.model';
import { Patients } from '../../../models/list/patients.model';
import { IndividualWaitingListComponent } from '../waiting-room/individual/individual-list.component';
import { CreateGroupPopupComponent } from './group/create-group-popup.component';
import { ModifyPatientPopupComponent } from '../../centre/manage-patient-user/modify-patient-popup.component';
import { ConsultationType, ConsultationValue } from '../../../models/consultation/consultation.model';

@Component({
  selector: 'waiting-room',
  templateUrl: 'waiting-room.component.html'
})
export class WaitingRoomComponent implements OnInit, OnDestroy {
  @ViewChild('individualList') individualChild;
  @ViewChild('groupList') groupChild;
  @ViewChild('groupTemplateList') groupTemplateChild;
  public timeout = AppConstants.refreshTime.timeout; // timeout 3 minutes
  public patientSelected = [];
  public tabUpdate = [false, false, false]; // if true then call setPage to reload list
  public selectedTab = 0; // current selected tab
  public refreshTimeOut;
  public indexTab = 0;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    private router: Router,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.titleService.setTitle('TMB waiting room');
    // set time out to refresh list
    this.setInterval();
  }

  ngOnDestroy() {
    this.clearTimeout();
  }

  clearTimeout() {
    // clear timeout
    if (this.refreshTimeOut) {
      clearInterval(this.refreshTimeOut);
    }
  }

  setInterval() {
    this.refreshTimeOut = setInterval(() => this.refreshList(), this.timeout);
  }

  refreshList() {
    this.refreshSelectedTab(this.selectedTab);
    this.resetTabUpdate(this.selectedTab);
  }

  resetTabUpdate(selectTabIndex) {
    for (let i = 0; i < this.tabUpdate.length; i++) {
      if (i !== selectTabIndex) {
        this.tabUpdate[i] = true;
      }
    }
  }

  /**
   * Refresh data in selected tab
   * @param selectTabIndex
   */
  refreshSelectedTab(selectTabIndex) {
    switch (selectTabIndex) {
      case 0:
          this.individualChild.refreshPage(false);
        //this.individualChild.reloadPage(this.individualChild.page.pageNumber, this.individualChild.dataRow, false);
        break;
      case 1:
         this.groupChild.refreshPage(false);
        //this.groupChild.reloadPage(this.groupChild.page.pageNumber, this.groupChild.dataRow, false);
        break;
      case 2:
        this.groupTemplateChild.refreshPage(false);
        //this.groupTemplateChild.reloadPage(this.groupTemplateChild.page.pageNumber, this.groupTemplateChild.dataRow, false);
        break;
    }
    this.tabUpdate[selectTabIndex] = false;
  }

  /**
   * Update data table data in selected tab
   * @param selectTabIndex
   */
  updateSelectedTabLayout(selectTabIndex) {
    switch (selectTabIndex) {
      case 0:
        this.individualChild.updateTableLayout();
        break;
      case 1:
        this.groupChild.updateTableLayout();
        break;
      case 2:
        this.groupTemplateChild.updateTableLayout();
        break;
    }
  }

  searchPatient() {
    this.router.navigate(['/consultation/search-patient']);
  }

  previousWaitingRoom() {
    this.router.navigate(['/consultation/previous-waiting-room']);
  }

  onCreateGroup(patientArr) {
    let patientREF = '';
    for (let i = 0; i < this.patientSelected.length; i++) {
      if (this.patientSelected[i].status !== ConsultationType.Consultation || this.patientSelected[i].groupId !== null) {
        patientREF += (patientREF !== '' ? ', ' : '') + this.patientSelected[i].patientREF;
      }
    }
    if (patientREF !== '') {
      this.dialogService.openErrorDialog({
        message: Utility.stringFormat(AppMessages.groupConsultant.errorAddPatientStatus, [patientREF])
      });
    } else {
      const data = {
        patientMembers: this.patientSelected
      };
      this.clearTimeout();
      this.dialogService.openComponentDialog(CreateGroupPopupComponent, data, { 'width': '800px' }).subscribe(result => {
        if (result) {
          this.individualChild.clearSelectedPatient();
          this.refreshList();
          // Change tab group
          this.indexTab = 1;
        }
        // set timeout again
        this.setInterval();
      });
    }
  }

  updatePatientSelected(patientArr) {
    this.patientSelected = patientArr;
  }

  /**
   * when a tab was selected, check and reload list if tabUpdate of that tab = true
   * @param event
   */
  onSelectedTabChange(event) {
    this.selectedTab = event.index;
    // refresh data in selected tab
    if (this.tabUpdate[this.selectedTab] === true) {
      this.refreshSelectedTab(this.selectedTab);
    } else {
      this.updateSelectedTabLayout(this.selectedTab);
    }
    /*   if (this.tabUpdate[this.selectedTab] === true) {
        if (this.selectedTab === 1) {
          this.groupChild.setPage({ offset: 0 });
        } else {
          this.individualChild.setPage({ offset: 0 });
        }
        this.tabUpdate[this.selectedTab] = false;
      } else { // update layout
        if (this.selectedTab === 1) {
          this.groupChild.updateTableLayout();
        } else {
          this.individualChild.updateTableLayout();
        }
      } */
  }

  /**
   * update list Individual when a group in Group list was dissmiss
   */
  updateIndividualList() {
    if (this.selectedTab === 0) {
      // this.individualChild.setPage({ offset: 0 });
      this.individualChild.reloadPage(this.individualChild.page.pageNumber, this.individualChild.dataRow, false);
    } else {
      this.tabUpdate[0] = true;
    }
  }

  /**
   * Add new patient funtion
   */
  onAddPatientAccount(): void {
    this.dialogService.openComponentDialog(ModifyPatientPopupComponent, {
      isFromWaitingRoom: true
    }, { width: '80%' }).subscribe(
      result => {
        if (result) {
          this.individualChild.reloadPage(this.individualChild.page.pageNumber, this.individualChild.dataRow, false);
        }
      });
  }

  onCreateGroupTemplate() {
    this.groupTemplateChild.createGroupTemplate();
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/waiting-room.component.ts